import React from "react";

const CommentSymbolIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 59 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.8595 48.5V34.0664C33.8595 25.0035 35.9408 17.6189 40.1036 11.9126C44.3759 6.0944 50.6748 2.29021 59.0003 0.5V11.4091C55.2757 12.3042 52.318 13.9825 50.1271 16.444C47.9361 18.7937 46.5121 21.6469 45.8548 25.0035H55.7139V48.5H33.8595ZM0.666992 48.5V34.0664C0.666992 25.0035 2.74837 17.6189 6.91112 11.9126C11.1834 6.0944 17.4276 2.29021 25.6435 0.5V11.4091C21.9189 12.3042 18.9612 13.9825 16.7703 16.444C14.5794 18.7937 13.1553 21.6469 12.498 25.0035H22.3571V48.5H0.666992Z"
        fill="#1D4ED8"
      />
    </svg>
  );
};

export default CommentSymbolIcon;
